import React from 'react';
// import LanguageSwitcher from '../../shared-components/LanguageSwitcher';

function ToolbarLayoutAdmin({ adminPage = false }: { adminPage: boolean }) {
	return <></>;
}

export default React.memo(ToolbarLayoutAdmin);
